import AuthLayout from "../../layout/AuthLayout.jsx";
import AuthImage from "../../mosaic/images/auth-image.jpg";
import {useTranslation} from "react-i18next";
import FormControl from "../../components/form/FormControl.jsx";
import FormButton from "../../components/form/FormButton.jsx";
import {useContext, useEffect, useState} from "react";
import {Form, useNavigate, useSearchParams} from "react-router-dom";
import InfoBox from "../../components/InfoBox.jsx";
import LoadingComponent from "../../components/LoadingComponent.jsx";
import useDownloadState from "../../api/utilities/useDownloadState.js";
import {GlobalContext} from "../../utils/context/GlobalContextProvider.jsx";
import IdentityImage from "../../components/IdentityImage.jsx";
import {AuthenticationApi} from "../../api/authority/generated/index";
import FormError from "../../components/form/FormError.jsx";
import ServiceLayout from "../../layout/ServiceLayout.jsx";

export default function ContinueFromEmail() {

    let {t} = useTranslation();
    let navigate = useNavigate();

    let [searchParams, setSearchParams] = useSearchParams();
    let token = searchParams.get('token');

    let {getAuthorityConfiguration, setCurrentIdentity} = useContext(GlobalContext);
    let [state, setDownloading, setResult, setError] = useDownloadState();

    useEffect(() => {
        setDownloading(true);
        new AuthenticationApi(getAuthorityConfiguration())
            .confirmEmail({
                token: token,
            })
            .then((newIdentity) => {
                setCurrentIdentity(newIdentity);
                navigate('/');
            })
            .catch((e) => setError(e))
            .finally(() => setDownloading(false));
    }, [token])


    return (
        <LoadingComponent loading={state.downloading}>
            <ServiceLayout title={t('auth.email-confirmation')}>
                {state.error && <FormError error={state.error}/>}
            </ServiceLayout>
        </LoadingComponent>
    );
}
